import { render, staticRenderFns } from "./InstagramInterface.vue?vue&type=template&id=1a50f15e&"
import script from "./InstagramInterface.vue?vue&type=script&lang=js&"
export * from "./InstagramInterface.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports